import { render, staticRenderFns } from "./MyPopupEdit.vue?vue&type=template&id=4b81971e&lang=pug&"
import script from "./MyPopupEdit.vue?vue&type=script&lang=js&"
export * from "./MyPopupEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports